import GradientText from 'components/GradientText';
import './styles.scss';
import background from 'images/our-history.jpg';
import { useSelector } from 'react-redux';
import { selectAboutUsPageIsLoading } from 'store/slices/AboutUsSlice';
import { useAnimation } from 'hooks/useAnimation';
import { useEffect, useRef, useState } from 'react';

const OurHistory = ({ title, cards = [] }) => {
    const loading = useSelector(selectAboutUsPageIsLoading);
    const container = useRef();
    const [ready, setReady] = useState(false);

    useEffect(() => {
        const id = setTimeout(() => setReady(true), 1000);

        return () => clearTimeout(id);
    }, []);

    useAnimation({
        items: ['.our-history-cards'],
        container,
        dependencies: [loading, ready],
    });

    return (
        <section className="container" ref={container}>
            <div className="our-history-section" style={{ backgroundImage: `url(${background})` }}>
                <div className="our-history-section-gradient" />
                <div className="our-history">
                    <div className="our-history__title h1 has-animation">{title}</div>
                    <div className="our-history-cards">
                        {cards.map(item => (
                            <div key={item.title} className="history-card-wrapper">
                                <div className="angle-decor" />
                                <div className="history-card">
                                    <GradientText textColor="white">
                                        <em>{item.title}</em>
                                    </GradientText>
                                    <div className="body1 opacity-80">{item.text}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};
export default OurHistory;
